export default __webpack_public_path__ + "static/media/WhiteHome.b667eadc.svg";